import styled from 'styled-components';
import { Nav, Table, UncontrolledPopover } from 'reactstrap';

import { Modal } from 'shared/components/modal/Modals';
import { TextField } from 'shared/components/form/Inputs';
import { colors, fonts, fontSizes, device } from 'shared/defaultTheme';

const ClientManagementWrapper = styled.div`
  display: flex;

  .backgroundBox-wrapper {
    min-height: 563px;
    margin-bottom: 25px;
    @media ${device.sm} {
      margin-left: 4px;
      flex: 0 0 98%;
      width: 98%;
    }
    @media ${device.md} {
      margin-left: 14px;
      flex: 0 0 97%;
      width: 97%;
    }
    @media ${device.lg} {
      margin-left: 14px;
      flex: 0 0 97%;
    }

    @media ${device.xl} {
      flex: 0 0 91%;
      margin-left: 0;
    }
  }
`;

const NavHome = styled(Nav)`
  border-bottom: 1px solid ${colors.pattens};
  margin-top: 26px;
  @media ${device.sm} {
    display: block;
  }
  @media ${device.md} {
    display: flex;
  }
  @media ${device.lg} {
    display: flex;
  }

  @media ${device.xl} {
    display: flex;
  }
`;

const BasicDataWrapper = styled.div`
  @media ${device.sm} {
    .row-basic-data {
      display: flex;
      justify-content: center;
    }
    .col-input-file {
      padding-top: 50px;
      flex: 0 0 80% !important;
      max-width: 80%;
    }
    .col-form {
      padding-top: 28px;
      flex: 0 0 100%;
      max-width: 100%;
      .form__form-group {
        margin-bottom: 13px !important;
      }
    }
  }
  @media ${device.md} {
    .row-basic-data {
      display: flex;
      justify-content: center;
    }
    .col-input-file {
      padding-top: 50px;
      flex: 0 0 45% !important;
      max-width: 45%;
    }
    .col-form {
      padding-top: 28px;
      flex: 0 0 100%;
      max-width: 100%;
      .form__form-group {
        margin-bottom: 13px !important;
      }
    }
  }
  @media ${device.lg} {
    .row-basic-data {
      display: flex;
      justify-content: unset;
    }
    .col-input-file {
      padding-top: 50px;
      flex: 0 0 28% !important;
      max-width: 25%;
    }
    .col-form {
      padding-top: 28px;
      flex: 0 0 75%;
      max-width: 75%;
      .form__form-group {
        margin-bottom: 13px !important;
      }
    }
  }
  @media ${device.xl} {
    .row-basic-data {
      display: flex;
      justify-content: unset;
    }
    .col-input-file {
      padding-top: 50px;
      flex: 0 0 20% !important;
      max-width: 25%;
    }
    .col-form {
      padding-top: 28px;
      flex: 0 0 75%;
      max-width: 75%;
      .form__form-group {
        margin-bottom: 13px !important;
      }
    }
  }
  .custom-input-file {
    .image-uploader__upload-section {
      border-radius: 4px;
      height: 200px;
      justify-content: center;
      div {
        flex-direction: column;
        align-items: center !important;
        justify-content: center !important;
        svg {
          margin-top: 7px !important;
          align-self: center !important;
        }
      }
    }
  }
  .text-contact {
    font-family: ${fonts.default};
    font-size: 12px;
    font-weight: bold;
    margin-top: 16px;
    margin-bottom: 5px;
    text-transform: uppercase;
  }
  .text-contact-required {
    color: ${colors.venetianRed};
    font-family: ${fonts.default};
    font-size: 12px;
    font-style: italic;
    text-transform: none;
  }
  .form-divider {
    border-top: 1px solid ${colors.black};
    width: 97%;
    margin-bottom: -12px;
  }

  .label-input {
    margin-bottom: 9px !important;
  }
  .client-custom-select {
    box-sizing: border-box;
    border: 1px solid ${colors.pattens};
    border-radius: 4px;
    box-shadow: none;
    svg {
      height: 21px;
      width: 16px;
    }
  }
  .client-dropdown-search {
    box-sizing: border-box;
    height: 38px;
    border: 1px solid ${colors.pattens};
    border-radius: 4px;
  }
`;

const CustomDataFormWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 28px;
  @media ${device.sm} {
    .w-custom-data-form {
      width: 100%;
      justify-content: center;
    }
  }
  @media ${device.md} {
    .w-custom-data-form {
      width: 70%;
    }
  }
  @media ${device.lg} {
    .w-custom-data-form {
      width: 50%;
    }
  }
  @media ${device.xl} {
    .w-custom-data-form {
      width: 50%;
    }
  }
  .input-date {
    float: unset;
  }
`;

const ContactsWrapper = styled.div`
  @media ${device.sm} {
    .table {
      overflow-x: auto;
      display: block;
      max-width: fit-content;
      white-space: nowrap;
      thead th:nth-child(6) {
        position: sticky;
        right: 100px;
        z-index: 2;
        background: white;
      }
      tbody td:nth-child(6) {
        position: sticky;
        right: 120px;
        z-index: 2;
        background: white;
        width: 77px;
      }
      thead th:last-child {
        position: sticky;
        right: 0;
        z-index: 2;
        background: white;
      }
      tbody td:last-child {
        position: sticky;
        right: 0;
        z-index: 2;
        background: white;
      }
    }
    .w-search-contacts {
      width: 100%;
    }
    .action-header-mobile {
      flex-direction: column-reverse;
      .w-container-search-mobile {
        width: 100% !important;
        margin-top: 10px;
      }
    }
  }
  @media ${device.md} {
    .table {
      overflow-x: auto;
      display: block;
      max-width: fit-content;
      white-space: nowrap;
      thead th:nth-child(6) {
        position: sticky;
        right: 100px;
        z-index: 2;
        background: white;
      }
      tbody td:nth-child(6) {
        position: sticky;
        right: 120px;
        z-index: 2;
        background: white;
        width: 77px;
      }
      thead th:last-child {
        position: sticky;
        right: 0;
        z-index: 2;
        background: white;
      }
      tbody td:last-child {
        position: sticky;
        right: 0;
        z-index: 2;
        background: white;
      }
    }
    .w-search-contacts {
      width: 100%;
    }
  }
  @media ${device.lg} {
    .table {
      overflow-x: auto;
      display: block;
      max-width: fit-content;
      white-space: nowrap;
      thead th:nth-child(6) {
        position: sticky;
        right: 100px;
        z-index: 2;
        background: white;
      }
      tbody td:nth-child(6) {
        position: sticky;
        right: 120px;
        z-index: 2;
        background: white;
        width: 77px;
      }
      thead th:last-child {
        position: sticky;
        right: 0;
        z-index: 2;
        background: white;
      }
      tbody td:last-child {
        position: sticky;
        right: 0;
        z-index: 2;
        background: white;
      }
    }
    .w-search-contacts {
      width: 100%;
    }
  }
  @media ${device.xl} {
    .table {
      overflow-x: auto;
      display: block;
      max-width: 100%;
      white-space: nowrap;
      thead th:nth-child(6) {
        position: sticky;
        right: 100px;
        z-index: 2;
        background: white;
      }
      tbody td:nth-child(6) {
        position: sticky;
        right: 120px;
        z-index: 2;
        background: white;
        width: 77px;
      }
      thead th:last-child {
        position: sticky;
        right: 0;
        z-index: 2;
        background: white;
      }
      tbody td:last-child {
        position: sticky;
        right: 0;
        z-index: 2;
        background: white;
      }
    }
    .table-notfound {
      display: table;
    }
    .w-search-contacts {
      width: 100%;
    }
  }
  .btn-action-contacts {
    height: 41px;
    align-items: center;
  }
  padding-top: 28px;
  th {
    border-bottom: 1px solid ${colors.pattens} !important;
  }
  td {
    border-top: none !important;
  }
  .small-column {
    width: 6%;
  }
  .default-column {
    width: 15%;
  }
  .large-column {
    width: 20%;
  }
  .empty-data-container {
    display: flex;
    flex-direction: column;
    margin-top: 5px;
    justify-content: center;
    align-items: center;
    width: 100%;
    svg {
      fill: ${colors.suvaGrey};
      height: 65px;
      width: 57px;
      margin-bottom: 13px;
    }
    span {
      color: ${colors.suvaGrey};
      font-family: ${fonts.default};
      font-size: ${fontSizes.sm}px;
      font-weight: 500;
      letter-spacing: 0;
      line-height: 16px;
    }
  }
  .sort-collapse {
    position: absolute;
    top: 2rem;
    right: 2rem;
    z-index: 300;
  }
  .info-body-name {
    white-space: nowrap;
    width: 130px;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .info-body-surname {
    white-space: nowrap;
    width: 150px;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .info-body-description {
    white-space: nowrap;
    width: 180px;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .info-body-phone {
    white-space: nowrap;
    width: 100px;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .info-body-email {
    white-space: nowrap;
    width: 160px;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .action-row-contact {
    cursor: pointer;
    &:hover {
      background-color: ${colors.lightGray};
      td:last-child {
        background-color: #eee;
      }
      td:nth-child(6) {
        background-color: #eee;
      }
    }
  }
`;

const ContactModalFormWrapper = styled(Modal)`
  top: 18%;
  .modal-content {
    border-radius: 2px;
    padding: 30px 22.5px 30px 22.5px;
  }
  .modal-body {
    padding: 0 !important;
    .row {
      margin-left: 0 !important;
      margin-right: 0 !important;
      .col-sm-6,
      .col-sm-12 {
        padding-left: 0 !important;
        padding-right: 0 !important;
      }
      .col-left {
        padding-right: 15px !important;
      }
    }
  }
  .title-wrapper {
    border-bottom: 1px solid ${colors.black};
    padding-bottom: 15px;
    margin-bottom: 23.5px;
    width: 100%;
  }
  .title {
    color: ${colors.black};
    font-family: ${fonts.default};
    font-size: ${fontSizes.xlg}px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 24px;
  }
  .give-access-container {
    display: flex;
    flex-direction: row-reverse;
    justify-content: flex-end;
    align-items: center;
    width: 235px;
    top: 32px;
    .give-access-icon-label {
      margin-top: -11px;
      display: flex;
      align-items: flex-end;
      .label-input {
        line-height: 10px;
      }
    }
  }
  .sync-client-link {
    display: flex;
    flex-direction: row-reverse;
    justify-content: flex-end;
    align-items: center;
    top: 32px;
    .sync-client-link-action {
      position: relative;
      top: -4px;
    }
  }

  .client-link-info {
    height: 42px;
    cursor: pointer;
    &:hover {
      border-bottom: 1px solid ${colors.lightBlue};
      width: 123px;
    }
  }

  .no-have-contract-client-link-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 70px;
    position: relative;
    top: 15px;
    .no-have-contract-client-link-information-icon {
      height: 18px;
      width: 18px;
      fill: ${colors.lightBlue};
    }
    .no-have-contract-client-link-span {
      color: ${colors.lightBlue};
      font-family: ${fonts.default};
      font-size: ${fontSizes.xs}px;
      font-weight: bold;
      letter-spacing: 0;
      line-height: 15px;
    }
    .no-have-contract-client-link-btn {
      height: 28px;
      width: 152px;
      border-radius: 2px;
      background-color: ${colors.lightBlue};
      display: flex;
      justify-content: center;
      align-items: center;
      color: ${colors.white};
      box-shadow: 0 1px 1px 0 ${colors.pattens};
      cursor: pointer;
      &:hover {
        border: 1px solid;
        border-radius: 2px;
        background-color: ${colors.white};
        border-color: ${colors.lightBlue};
        color: ${colors.lightBlue};
      }
    }
  }

  .custom-checkbox .custom-control-label::before {
    border-radius: 0;
  }

  .required-mark {
    color: ${colors.error};
  }

  .what-is-client-link-icon {
    height: 15px;
    width: 15px;
    fill: ${colors.lightBlue};
  }

  .what-is-client-link-span {
    color: ${colors.lightBlue};
    font-family: ${fonts.default};
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 68px;
  }
  .contact-custom-select {
    box-sizing: border-box;
    border: 1px solid ${colors.pattens};
    border-radius: 4px;
    box-shadow: none;
    svg {
      height: 18px;
      width: 15px;
    }
  }
`;

const TdAction = styled.div`
  width: 88%;
`;

const TdActionNotify = styled.td`
  width: 12%;
`;

const NotificationWrapper = styled.div`
  @media ${device.sm} {
    display: block;
    justify-content: center;
    margin-top: 30px;
  }
  @media ${device.md} {
    display: flex;
    justify-content: center;
    margin-top: 30px;
  }
  @media ${device.lg} {
    display: flex;
    margin-left: 4px;
    justify-content: center;
    margin-top: 30px;
  }
  @media ${device.xl} {
    display: flex;
    justify-content: center;
    margin-top: 30px;
  }
`;

const NotificationTableBackground = styled.div`
  @media ${device.sm} {
    flex: 0 0 94%;
    .w-search-notification {
      width: 99%;
    }
  }
  @media ${device.md} {
    flex: 0 0 94%;
    .w-search-notification {
      width: 65%;
    }
  }
  @media ${device.lg} {
    flex: 0 0 93%;
    .w-search-notification {
      width: 55%;
    }
  }
  @media ${device.xl} {
    flex: 0 0 90%;
    .w-search-notification {
      width: 35%;
    }
  }
  .table-notifications {
    height: 660px;
  }
  .container-action-button {
    height: 42px;
    align-items: center;
  }
`;

const Popover = styled(UncontrolledPopover)`
  .popover {
    width: auto;
    border: none;
    box-shadow: 0 0 4px 0 ${colors.pattens};
    .popover-body {
      padding: 0;
      width: 191px;
      text-align: center;
    }
  }
  .popover .arrow::before,
  .popover .arrow::after {
    border-style: none;
  }
  .label-icon-sort {
    height: 25px;
  }
`;

const OptionMenu = styled.div`
  width: 100%;
  cursor: pointer;
  height: 34px;
  padding: 5px;
  padding-left: 14px;
  &:hover {
    background-color: ${colors.whiteSmoke};
  }
`;

const SearchNotification = styled(TextField)`
  input {
    border-radius: 2px;
    color: ${colors.suvaGrey};
    font-size: ${fontSizes.sm}px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 19px;
    padding: 8px 4px;
    height: 35px;
  }
`;

const DivMenuIcon = styled.div`
  text-align: center;
  width: 30%;
`;

const OptionMenuTable = styled.div`
  pointer-events: ${({ isDisible }) => (isDisible ? 'none' : 'initial')};
  color: ${({ isDisible }) => (isDisible ? colors.lightSilver : 'initial')};
  width: 100%;
  cursor: pointer;
  height: 30px;
  padding: 0.5rem 0.75rem;
  &:hover {
    background-color: ${colors.whiteSmoke};
  }
`;

const TableNotification = styled(Table)`
  @media ${device.sm} {
    overflow-x: auto;
    display: block;
    max-width: fit-content;
    white-space: nowrap;
  }
  @media ${device.md} {
  }
  @media ${device.lg} {
  }
  @media ${device.xl} {
  }
  .action-row-communication {
    cursor: pointer;
    &:hover {
      background-color: ${colors.lightGray};
    }
  }
`;

const TdName = styled.td`
  width: 20%;
  cursor: pointer;
  .link-name-notification {
    display: flex;
    width: 100%;
    P {
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      width: 160px;
      flex: 1 1 auto;
    }
  }
`;

const Td = styled.td`
  width: 20%;
`;

const Thead = styled.thead`
  font-family: ${fonts.black};
  font-size: ${fontSizes.xs}px;
`;

const Tbody = styled.tbody`
  font-size: ${fontSizes.sm}px;
`;

const TBodyTr = styled.tr`
  font-family: ${({ numAnswersUnread }) => (numAnswersUnread > 0 ? fonts.bold : fonts.default)};
`;

const DocumentWrapper = styled.div`
  @media ${device.sm} {
    display: flex;
    justify-content: center;
    margin-top: 30px;
  }
  @media ${device.md} {
    display: flex;
    justify-content: center;
    margin-top: 30px;
  }
  @media ${device.lg} {
    display: flex;
    justify-content: center;
    margin-top: 30px;
  }
  @media ${device.xl} {
    display: flex;
    justify-content: center;
    margin-top: 30px;
  }
`;

const DocumentTableBackground = styled.div`
  @media ${device.sm} {
    flex: 0 0 97%;
    width: 100px;
  }
  @media ${device.md} {
    flex: 0 0 98%;
    width: 100px;
  }
  @media ${device.lg} {
    flex: 0 0 98%;
    width: 100px;
  }
  @media ${device.xl} {
    flex: 0 0 90%;
    width: 100px;
  }
`;

const NotifiFormWrapper = styled.div`
  padding: 0 20px;
  padding-bottom: 26px;
  display: flex;
  flex-direction: column;
  align-items: center;

  .row-title {
    border-bottom: 1px solid ${colors.spanishGray};
    padding: 0;
    padding-bottom: 17px;
    width: 100%;

    h3 {
      color: ${colors.black};
      font-family: ${fonts.default};
      font-size: ${fontSizes.xlg}px;
      font-weight: bold;
      letter-spacing: 0;
      line-height: 24px;
    }
  }
  .row-content {
    padding: 0;
    .col-sm-12 {
      padding: 0;
    }
  }
  .form-field {
    margin-top: 26px;
    .required-mark {
      color: ${colors.error};
    }
    .row {
      padding: 0;
      margin-right: 0;
      margin-left: 0;
    }
  }
  .row-border-bottom {
    border-bottom: 1px solid ${colors.spanishGray};
    padding-bottom: 10px !important;
    margin-bottom: 24px;
  }
  .button-icon {
    background-color: ${colors.transparent};
    color: ${colors.black};
    font-family: ${fonts.default};
    font-size: ${fontSizes.md}px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 19px;
    display: flex;
    flex-direction: row;
    align-items: center;
    width: auto;

    &:active {
      opacity: 0.5;
    }
  }
`;

const FormModal = styled(Modal)`
  top: 10%;
  .modal-content {
    border-radius: 4px;
  }
  .modal-header {
    border: 0;
    height: 36px;
    padding-top: 20px;
    padding-bottom: 0;

    svg {
      fill: ${colors.suvaGrey} !important;
      height: 18px !important;
      width: 18px !important;
    }
    .div-icon-wrapper {
      width: 26%;
      height: 35px;
    }
  }
  .modal-body {
    padding: 0.6rem;
  }
`;

const EmptyForm = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;

  svg {
    fill: ${colors.suvaGrey};
    height: 62px;
    width: 62px;
    margin-bottom: 7px;
  }

  span {
    color: ${colors.suvaGrey};
    margin-bottom: 5px;
  }

  .subText {
    font-size: ${fontSizes.xs}px;
  }
`;

const CustomFieldText = styled.span`
  font-family: ${fonts.default};
  font-weight: 500;
  letter-spacing: 0;
  line-height: 16px;
  @media ${device.sm} {
    font-size: ${fontSizes.xxs}px;
  }
  @media ${device.md} {
    font-size: ${fontSizes.xxs}px;
  }
  @media ${device.lg} {
    font-size: ${fontSizes.sm}px;
  }

  @media ${device.xl} {
    font-size: ${fontSizes.sm}px;
  }
`;

const PublicDocumentsWrapper = styled.div`
  padding: 0 20px;
  padding-bottom: 26px;
  display: flex;
  flex-direction: column;
  align-items: center;

  .public-data-container {
    position: relative;
    left: 1.3rem;
  }

  .required-mark {
    color: ${colors.error};
  }

  .row-title {
    border-bottom: 1px solid ${colors.spanishGray};
    padding: 0;
    padding-bottom: 17px;
    width: 100%;

    h3 {
      color: ${colors.black};
      font-family: ${fonts.default};
      font-size: ${fontSizes.xlg}px;
      font-weight: bold;
      letter-spacing: 0;
      line-height: 24px;
    }
  }
  .sub-title {
    font-family: ${fonts.default};
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 19px;
    color: ${colors.black};
  }
  .sub-title {
    font-family: ${fonts.default};
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 19px;
    color: ${colors.black};
  }
  .container-public {
    width: 88%;
  }
  .upload-name {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    width: 190px;
    flex: 1 1 auto;
  }
  .custom-control {
    min-height: 0;
  }
  .e-multiselect {
    input::placeholder {
      position: relative;
      left: 8px;
      top: 4px;
    }
  }
  .list-public-container {
    min-height: auto;
    max-height: 315px;
    overflow: auto;
  }
`;

const CheckboxClientLink = styled.div`
  input {
    &:checked {
      ~ label {
        &::before {
          background-color: ${({ isDisabled }) =>
            isDisabled ? `${colors.suvaGrey}` : `${colors.davysGrey}`} !important;
          border-color: ${({ isDisabled }) =>
            isDisabled ? `${colors.suvaGrey}` : `${colors.davysGrey}`} !important;
        }
      }
    }
  }
`;

const PopoverFilter = styled(UncontrolledPopover)`
  .popover {
    width: auto;
    border: none;
    box-shadow: 0 0 4px 0 #d6d8d9;
    .popover-body {
      padding: 0;
    }
  }
  .popover .arrow::before,
  .popover .arrow::after {
    border-style: none;
  }
`;

const OptionMenuFilter = styled.div`
  width: 208px;
  cursor: pointer;
  padding: 12px;
  .filter-name {
    color: ${colors.black};
    font-family: ${fonts.roboto};
    font-size: 14px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 15px;
  }
  .filter-i18-name {
    color: ${colors.suvaGrey};
    font-family: ${fonts.roboto};
    font-size: 13px;
    letter-spacing: 0;
    line-height: 18px;
  }
`;

export {
  ClientManagementWrapper,
  NavHome,
  BasicDataWrapper,
  CustomDataFormWrapper,
  ContactsWrapper,
  ContactModalFormWrapper,
  TdAction,
  NotificationWrapper,
  NotificationTableBackground,
  Popover,
  SearchNotification,
  OptionMenu,
  DivMenuIcon,
  OptionMenuTable,
  TableNotification,
  TdName,
  Td,
  Thead,
  Tbody,
  TBodyTr,
  NotifiFormWrapper,
  DocumentWrapper,
  DocumentTableBackground,
  FormModal,
  TdActionNotify,
  EmptyForm,
  CustomFieldText,
  PublicDocumentsWrapper,
  CheckboxClientLink,
  PopoverFilter,
  OptionMenuFilter,
};
